import { DateTime } from 'luxon';
import { GlobalState } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import MruMap from "./MruMap.js";
/**
 * @typedef {{
 *  data : {
 *  id: string;
 *  data : {
 *    url: string;
 *  },
 *  path: string
 * }
 * }} Resource
 * 
 */
export default class ResourceCache {
  #mruCache;
  #delegate;
  #slopSeconds;
  constructor(opts) {
    const {
      delegate,
      slopSeconds = 30
    } = opts || {};
    this.#mruCache = new MruMap();
    this.#delegate = delegate;
    this.#slopSeconds = slopSeconds;
  }

  /**
   * 
   * @param {DateTime} dateTime 
   */
  async get(dateTime) {
    let item = this.#mruCache.get(dateTime.toUTC().toISO());
    if (item) {
      if (this.isExpired(item)) {
        const delegate = this.#delegate.item(Attributes.get('rsrc.path', item));
        const response = await GlobalState.dispatch(delegate.get());
        item = delegate.toObjectRef(response);
        this.#mruCache.set(dateTime.toUTC().toISO(), item);
      }
    }
    return item;
  }

  /**
   * 
   * @param {DateTime} dateTime 
   * @param {Resource} resource 
   */
  set(dateTime, resource) {
    this.#mruCache.set(dateTime.toUTC().toISO(), resource);
  }

  /**
   * 
   * @param {Resource} resource 
   * @returns 
   */
  isExpired(resource) {
    const rUrl = Attributes.get('rsrc.url', resource);
    const url = new URL(rUrl);
    const expiresIn = parseInt(url.searchParams.get('X-Goog-Expires'));
    const validFrom = DateTime.fromISO(url.searchParams.get('X-Goog-Date'));
    const expiresAt = validFrom.plus({
      seconds: expiresIn - this.#slopSeconds
    });
    return Date.now() >= expiresAt;
  }
}